import React, { useCallback, useEffect, useState } from 'react'

const MileageCalc = () => {

  const [inputData, setInputData] = useState({
    distance: "360",
    fuelConsumed: "7",
    fuelType: "Litre",
    fuelCost: "76.34",
    currency: "USD",
  })

  const [resultData, setResultData] = useState({
    mileage: "51.43",
    distance:"360",
    fuelType:"Litre",
    totalAmount: "534.38",
    currency:"USD"
  })

  const calculateMileage = useCallback(() => {
    
    const { distance, fuelConsumed, fuelType, fuelCost, currency } = inputData;
    if (distance && fuelConsumed && fuelCost) {
      const mileage = (distance / fuelConsumed).toFixed(2);
      const totalAmount = (fuelCost * fuelConsumed).toFixed(2);
      setResultData(prev => ({ ...prev, mileage,distance, fuelType, totalAmount, currency }))
    }
  }, [inputData])

  useEffect(()=>{
    calculateMileage()
  }, [calculateMileage])

  return (
    <div className="w-full max-w-[1000px] bg-gray-100 mx-auto py-[30px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]">
      <div className="max-w-[100%] lg:w-[50%] h-full bg-white p-[10px] md:p-[20px] py-[30px] md:py-[30px]">
        <div className="flex flex-col">
          <div className="text-gray-500 flex flex-col gap-[10px]">
            <h3 className="text-gray-700 font-medium text-[18px] border-b-2 pb-[15px] mb-[10px]">Mileage By Distance Travelled</h3>
            <div className="flex justify-between items-center">
              <h3 className="text-gray-500 font-medium text-[16px]">Distance Travelled</h3>
              <input
                className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                id=""
                name=""
                type="text"
                placeholder="250 Km"
                required
                value={inputData.distance}
                onChange={(e) => setInputData(prev => ({ ...prev, distance: e.target.value }))}
              />
            </div>
            <div className="flex justify-between items-center">
              <h3 className="text-gray-500 font-medium text-[16px]">Fuel Consumed</h3>
              <input
                className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                id=""
                name=""
                type="text"
                placeholder="7 Litre/Gallon"
                required
                value={inputData.fuelConsumed}
                onChange={(e) => setInputData(prev => ({ ...prev, fuelConsumed: e.target.value }))}
              />
            </div>
            <div className="flex justify-between items-center">
              <div className=""></div>
              <div className="flex gap-[20px] w-[180px]">
                <div className="flex items-center gap-[5px]">
                  <input onChange={(e) => setInputData(prev => ({ ...prev, fuelType: e.target.value }))} id="fuel-1" type="radio" name="fuel" value="Litre" checked={inputData.fuelType === "Litre"} className="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300" />
                  <label htmlFor="fuel-1" className="text-[16px] text-gray-500">
                    Litre
                  </label>
                </div>
                <div className="flex items-center gap-[5px]">
                  <input onChange={(e) => setInputData(prev => ({ ...prev, fuelType: e.target.value }))} id="fuel-2" type="radio" name="fuel" value="Gallon" checked={inputData.fuelType === "Gallon"}  className="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300" />
                  <label htmlFor="fuel-2" className="text-[16px] text-gray-500">
                    Gallon
                  </label>
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <h3 className="text-gray-500 font-medium text-[16px]">Cost/Unit Fuel</h3>
              <input
                className="rounded-md border text-gray-500 outline-none py-2 px-3 w-[180px] h-[50px]"
                id=""
                name=""
                type="text"
                placeholder="$34"
                required
                value={inputData.fuelCost}
                onChange={(e) => setInputData(prev => ({ ...prev, fuelCost: e.target.value }))}
              />
            </div>
            <div className="flex justify-between items-center">
              <h3 className="text-gray-500 font-medium text-[16px]">Currency</h3>
              <div className="">
                <select
                  className="border outline-none rounded-md w-[180px] h-[50px]"
                  id=""
                  name=""
                  required
                  value={inputData.currency}
                  onChange={(e) => setInputData(prev => ({ ...prev, currency: e.target.value }))}
                >
                  <option value="USD">US Dollar</option>
                  <option value="INR">Indian Rupee</option>
                </select>
              </div>
            </div>
            <button onClick={()=>calculateMileage()} className="w-full h-[50px] mt-[20px] bg-violet-500 hover:opacity-75 text-white font-medium text-[18px] rounded-lg shadow-2xl">Calculate</button>
          </div>
        </div>
      </div>
      <div className="w-[100%] lg:w-[50%] h-full flex flex-col gap-[20px]">
        <h3 className="text-white py-[2px] mb-[10px] h-[50px] flex items-center text-center justify-center px-[10px] font-medium text-[25px] bg-violet-500">Result</h3>
        <div className="flex flex-col justify-center items-center bg-gray-200 w-fit mx-auto p-[30px] rounded-full">
          <h1 className="text-[20px] font-medium text-gray-500">Mileage</h1>
          <div className="text-[60px] font-bold text-gray-700">{resultData.mileage}</div>
          <h3 className="text-gray-500">Km/{resultData.fuelType}</h3>
        </div>
        <div className="w-full text-gray-500 font-medium flex flex-col gap-[10px]">
          <div className=" flex items-center gap-[30px] justify-around text-[20px] mx-[15px]">
            <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">Units</div>
            <div className="w-[50%] text-center border-b-[1px] border-b-gray-400 pb-[5px] px-[5px]">Output</div>
          </div>
          <div className=" flex items-center justify-around text-[18px] text-gray-400">
            <div className="w-[50%] text-center">Distance</div>
            <div className="w-[50%] text-center">{resultData.distance} Km</div>
          </div>
          <div className=" flex items-center justify-around text-[18px] text-gray-400">
            <div className="w-[50%] text-center">Fuel</div>
            <div className="w-[50%] text-center">{resultData.fuelType}</div>
          </div>
          <div className=" flex items-center justify-around text-[18px] text-gray-400">
            <div className="w-[50%] text-center">Total Amount</div>
            <div className="w-[50%] text-center">{resultData.totalAmount + " " + resultData.currency} </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MileageCalc
